import { render, staticRenderFns } from "./TabSelect.vue?vue&type=template&id=ceb1e354&scoped=true&"
import script from "./TabSelect.vue?vue&type=script&lang=js&"
export * from "./TabSelect.vue?vue&type=script&lang=js&"
import style0 from "./TabSelect.vue?vue&type=style&index=0&id=ceb1e354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb1e354",
  null
  
)

export default component.exports